var $;

$ = require('jquery');

module.exports = (function() {
  $(document).ready(function() {
    $(".nav-link, .nav-link-logo").click(function(event) {
      var $anchor, navHeight, portfolioContentTop, usableTop;
      event.preventDefault();
      $anchor = $(this);
      navHeight = $("nav.nav").outerHeight();
      portfolioContentTop = $("section.portfolio-content").position().top;
      usableTop = 0;
      $("html, body").stop().animate({
        scrollTop: $($anchor.attr("href")).offset().top - navHeight
      }, 800);
    });
  });
})();
